/* unplugin-vue-components disabled */import script from "./JsonYamlPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonYamlPage.vue?vue&type=script&setup=true&lang=js"

import "./JsonYamlPage.vue?vue&type=style&index=0&id=6cbeb3d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cbeb3d8"]])

export default __exports__